// components/RequireAuth.js
import { Navigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

const RequireAuth = ({ children }) => {
  const auth = getAuth();
  return auth.currentUser ? children : <Navigate to="/" replace />;
};

export default RequireAuth;